import { render } from "./LicensingLicensing.vue?vue&type=template&id=10880372&scoped=true"
import script from "./LicensingLicensing.vue?vue&type=script&lang=js"
export * from "./LicensingLicensing.vue?vue&type=script&lang=js"

import "./LicensingLicensing.vue?vue&type=style&index=0&id=10880372&scoped=true&lang=css"

import exportComponent from "/home/rainnya_lime/桌面/project/waydro.id/Waydro.id/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10880372"]])

export default __exports__